import { Button, Row, Space, Spin, Tag } from "antd";
import React, { useEffect } from "react";
import { LogEvents, LoggerContext } from "../../../../context/logging";

export const ImageUpload = ({
  onDocumentAdd,
  onDocumentRemove,
  dataSource,
  setDataSource,
  loading,
  record,
  index,
}) => {
  const logger = React.useContext(LoggerContext);

  const fileInputRef = React.useRef(null);
  useEffect(() => {}, [record]);

  return (
    <>
      <input
        type="file"
        id="file"
        onChange={(e) => {
          console.log(e.target);
          console.log(e.target.files);
          onDocumentAdd(index, e.target.files);
        }}
        ref={fileInputRef}
        style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
      />
      {!(record?.item_image && record?.item_image != "") ? (
        <Tag
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            logger.log(LogEvents.uploadPoDocument, {});
            fileInputRef.current?.click();
          }}
        >
          Add Image
        </Tag>
      ) : (
        <Row className="p-2">
          <Tag
            closable
            onClick={(e) => {
              e.preventDefault();
              const newData = [...dataSource];
              newData[index].item_image = null;
              setDataSource(newData);
            }}
          >
            Remove Image
          </Tag>
        </Row>
      )}
    </>
  );
};
